import { render, staticRenderFns } from "./SessionConfigurationPage.vue?vue&type=template&id=60c000b5"
import script from "./SessionConfigurationPage.vue?vue&type=script&lang=js"
export * from "./SessionConfigurationPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports